<template>
  <div class="myteam">
    <van-nav-bar :title="title1"
                 @click-left="onClickLeft" />
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: ['title1'],
  components: {},
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__left i {
  color: black;
  font-size: 20px;
}
</style>